module.exports = __webpack_public_path__ + "static/img/xxzxyjxx2.21f2b3e3.png";